export const checkAttributesAgainstSchema = (eventAttributes, schemaAttributes) => {
  const schemaAttributeNames = new Set(schemaAttributes.map(({ name }) => name));
  const matchingEventAttributes = Object.keys(eventAttributes).filter((attr) =>
    schemaAttributeNames.has(attr),
  );
  if (matchingEventAttributes.length === 0) {
    return false;
  }
  return true;
};
